export default __webpack_public_path__ + "static/media/icon-sleep.add42e7b.png";